/* eslint-disable @typescript-eslint/no-explicit-any */
import { get, post, remove, handleClientError } from '../lib'
import { IPAScriptBody } from '../../types'

interface ResponseType {
  id: string
  name: string
  description: string
  config_count: number
  user: {
    id: number
    name: string
  }
  approved: boolean
  system: boolean
  created_at: string
  updated_at: string
}

interface orgResponseType {
  id: number
  name: string
  fleets: [
    {
      id: number
    }
  ]
  groups: [
    {
      id: number
    }
  ]
  users: [
    {
      id: number
    }
  ]
  deleteFlag: boolean
}

export const getAllScript = async (): Promise<ResponseType[]> => {
  return get<ResponseType[]>({
    path: '/ipa/script'
  })
}

export const getScript = async (id: string): Promise<ResponseType> => {
  return get<ResponseType>({
    path: `/ipa/script/${id}`
  })
}

export const createScript = async (
  body: IPAScriptBody
): Promise<IPAScriptBody> => {
  return post<IPAScriptBody, IPAScriptBody>({
    path: '/ipa/script',
    body
  })
}

export const removeScript = async (id: string): Promise<null> => {
  return remove({
    path: '/ipa/script',
    id
  })
}

export const listOrgsByUser = async (): Promise<orgResponseType[]> => {
  try {
    //TODO need elegant way of store and retrieve token and user info
    const token =
      JSON.parse(localStorage.getItem('wivi.access_token') as string) ||
      undefined
    return get<orgResponseType[]>({
      path: '/api/organization/listOrgsByUser',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token
      }
    })
  } catch (e: any) {
    if (e.message === 401) {
      window.location.href = '/ui/#!/'
    }
    throw e
  }
}
